import React from 'react';
import PropTypes from 'prop-types';

import {
  PreviewStudy,
  PreviewStudyIcon,
  PreviewStudyContainer,
  Loader,
} from './styles';

const PreviewStudyButton = (props) => {
  const {
    onPreviewStudy,
    isSurveyPreview,
    noMargin,
    loading,
    loadingPosition,
    disabled,
  } = props;

  return (
    <PreviewStudyContainer noMargin={noMargin}>
      {loading && loadingPosition === 'left' && (
        <Loader data-loader="preview-study-button-loader" />
      )}
      <PreviewStudy onClick={onPreviewStudy} disabled={disabled}>
        <PreviewStudyIcon src="/images/icon-preview-study.png" />
        {isSurveyPreview ? 'Preview Survey' : 'Preview My Study'}
      </PreviewStudy>
      {loading && loadingPosition === 'right' && (
        <Loader data-loader="preview-loader" />
      )}
    </PreviewStudyContainer>
  );
};

PreviewStudyButton.propTypes = {
  onPreviewStudy: PropTypes.func,
  isSurveyPreview: PropTypes.bool,
  noMargin: PropTypes.bool,
  loadingPosition: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

PreviewStudyButton.defaultProps = {
  onPreviewStudy: () => {},
  noMargin: false,
  isSurveyPreview: false,
  loadingPosition: 'left',
  loading: false,
  disabled: false,
};

export default PreviewStudyButton;
